import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { WithHotkey } from 'HOCs';

const NavigationLink = ({ Icon, name, path, currentSellerId, onClick, isActive, sidebarOpen, shortcuts }) => {
  const { t } = useTranslation();
  const shortcut = shortcuts?.find(s => s.command === name);
  const to = currentSellerId ? `/${currentSellerId}/${path}` : path;

  const itemClasses = `flex items-center gap-x-3 py-[6px] px-[9px] text-[13px] rounded-r-lg focus:outline-hidden border hover:border-theme-border-active hover:bg-theme-hover dark:hover:bg-theme-hover hover:text-theme-color-active dark:hover:text-theme-color-active ${isActive ? `!bg-theme-bg-active dark:!bg-theme-bg-active !border-l-[2px] !border-l-theme-border-active !text-theme-color-active dark:!text-theme-color-active` : 'border-transparent'}`;

  if (sidebarOpen) {
    return (
      <li className={`mr-[2px] ${itemClasses}`}>
        <span className="drag-handle shrink-0 cursor-grab select-none">
          <Icon style={{ width: '20px', height: '20px' }} className="fill-current" />
        </span>
        <Link
          to={to}
          onClick={onClick}
          onContextMenu={(e) => e.preventDefault()}
          title={t(name)}
          className="overflow-hidden text-ellipsis whitespace-nowrap max-w-36 min-w-0 w-full"
        >
          <WithHotkey hotkey={shortcut?.key} needShow={true}>{t(name)}</WithHotkey>
        </Link>
      </li>
    );
  }

  // Режим свёрнутого сайдбара – вся строка это одна ссылка
  return (
    <li className={`mr-[2px]`}>
      <Link
        to={to}
        onClick={onClick}
        onContextMenu={(e) => e.preventDefault()}
        title={t(name)}
        className={itemClasses}
      >
        <Icon style={{ width: '20px', height: '20px', marginRight: '-2px' }} className="fill-current" />
      </Link>
    </li>
  );
};

export default NavigationLink;
